// extracted by mini-css-extract-plugin
module.exports = {"toggleEntry":"_35avWAFDf6IGgiIx9uV8bp"};